//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

    props: {
        budget: {
            type: [Number, String],
            default: 0.00
        }
    },

    data: function data() {
        return {
            subtotal: 0
        };
    },
    created: function created() {
        var _this = this;

        App.event.listen('cart.data.loaded', function (_ref) {
            var data = _ref.data;

            var val = parseInt(data.subtotal);
            _this.subtotal = val;
        });

        App.event.listen('cart.updated', function (_ref2) {
            var data = _ref2.data;

            var val = parseInt(data.subtotal);
            _this.subtotal = val;
        });
    },


    computed: {
        subtotalValue: function subtotalValue() {
            return this.subtotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        budgetAvalible: function budgetAvalible() {
            var total = parseFloat(this.budget - this.subtotal);
            return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/cart-total/components/CartTotal.vue
// module id = IcGW
// module chunks = 4